// extracted by mini-css-extract-plugin
export default {"stickyFooter":"StickyFooter_stickyFooter__3+ARM","left":"StickyFooter_left__sUxHg","right":"StickyFooter_right__+-ckS"};